import React from 'react';
import { Link } from 'react-router-dom';
import { Landmark, Shield, Network, Users, ArrowRight } from 'lucide-react';

const PILLARS = [
  { icon: Landmark, title: 'Own nothing, control everything', text: 'Instead of holding assets in your own name, families place them inside legal entities and trusts. You control the decisions without being the legal owner.' },
  { icon: Shield, title: 'Protection by structure', text: 'Assets held by a properly run trust or company are generally kept separate from personal lawsuits and creditors.' },
  { icon: Network, title: 'An ecosystem of entities', text: 'Operating businesses, holding companies and trusts each have one job. Money flows between them according to written rules.' },
  { icon: Users, title: 'Built for generations', text: 'Trusts can outlive their founders, so wealth passes on under the family\'s rules instead of being split up or heavily taxed at each generation.' },
];

const SRAIVEST = [
  'Each small business on Sraivest is its own operating business, run by its owner.',
  'Sraivest earns fees and shares 25% of them back with the businesses. It keeps 75% for the platform.',
  'Investors own small pieces of many businesses instead of one big bet.',
];

export default function RockefellerPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="rockefeller-page">
      <div className="max-w-5xl mx-auto px-6 py-16 space-y-14">
        <div className="space-y-4">
          <p className="text-[#F7931A] text-sm tracking-widest uppercase">Wealth education</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>The Rockefeller Method</h1>
          <p className="text-gray-400 text-base md:text-lg max-w-2xl">A way of building and passing on wealth across generations, based on one idea: own nothing, control everything.</p>
        </div>
        <div className="grid sm:grid-cols-2 gap-5">
          {PILLARS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="p-6 rounded-2xl bg-white/5 border border-white/10 hover:border-[#00E676]/40 transition-colors">
              <Icon className="w-7 h-7 text-[#00E676] mb-3" />
              <h2 className="text-lg font-semibold mb-2">{title}</h2>
              <p className="text-sm text-gray-400">{text}</p>
            </div>
          ))}
        </div>
        <div className="p-6 rounded-2xl bg-[#00E676]/5 border border-[#00E676]/20 space-y-3">
          <h2 className="text-lg font-semibold">How the idea shows up in Sraivest</h2>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-300">{SRAIVEST.map((s) => <li key={s}>{s}</li>)}</ul>
          <Link to="/business" className="inline-flex items-center gap-2 text-[#00E676] text-sm font-semibold" data-testid="rockefeller-market-link">
            Explore the Small Business Market <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <p className="text-xs text-gray-500 max-w-3xl" data-testid="rockefeller-disclaimer">
          General education only. This is not legal, tax or investment advice. Trusts and entity structures must be set up and run correctly to work. Talk to a licensed estate-planning attorney and a CPA before acting.
        </p>
      </div>
    </div>
  );
}
